import { render, staticRenderFns } from "./FincasParaguai.vue?vue&type=template&id=4528ff0b&lang=pug"
import script from "./FincasParaguai.vue?vue&type=script&lang=js"
export * from "./FincasParaguai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports